import { Injectable } from '@angular/core';
import { Auth, signInWithEmailAndPassword, signOut } from '@angular/fire/auth';
import { Observable, Subject } from 'rxjs';
import { LoginData } from '../interfaces/login-data';
import { Usuario } from '../interfaces/usuario';



@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private usuario$ = new Subject<Usuario>();

  constructor(private auth: Auth) { }

  login({ email, password }: LoginData) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  getUserInfo() {
    const usuario = this.auth.currentUser.getIdTokenResult();
    usuario.then((res: any) => {
      this.usuario$.next({ id: res.claims.user_id, email: res.claims.email });
    })
      .catch((e) => console.log(e.message));
    // return this.auth.currentUser.getIdTokenResult();
  }

  getUsuario(): Observable<Usuario> {
    return this.usuario$.asObservable();
  }


  logout() {
    return signOut(this.auth);
  }




}
